// src/lib/constants/simulcast.ts

// Destination type labels (user-facing)
export const DESTINATION_TYPE_LABELS = {
  rtmp: 'Custom RTMP',
  facebook: 'Facebook Live',
  youtube: 'YouTube Live',
} as const;

// Simulcast constraints
export const SIMULCAST_CONSTRAINTS = {
  LABEL_MIN: 1,
  LABEL_MAX: 100,
  TITLE_MAX: 150,
  DESC_SHORT_MAX: 250,
  RTMP_SERVER_URL_MAX: 500,
  RTMP_STREAM_KEY_MAX: 500,
  RTMP_USER_MAX: 100,
  RTMP_PASS_MAX: 100,
} as const;

// YouTube create defaults (legacy-compatible)
export const YT_CREATE_DEFAULTS = {
  ytStreamCdIsReusable: true,
  ytStreamCdnIngestionType: 'rtmp',
  ytBrCdEnableAutoStart: true,
  ytBrCdEnableAutoStop: false,
  ytBrCdEnableDVR: true,
  ytBrCdEnableEmbed: false,
  ytBrCdRecordFromStart: true,
  ytBrCdEnableClosedCaptions: false,
  ytBrCdEnableContentEncryption: false,
} as const;
